import { render, staticRenderFns } from "./VenedorTemplate.vue?vue&type=template&id=79e7061a&scoped=true&"
import script from "./VenedorTemplate.vue?vue&type=script&lang=js&"
export * from "./VenedorTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VenedorTemplate.vue?vue&type=style&index=0&id=79e7061a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7061a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAvatar,VBadge,VBtn,VCarousel,VCarouselItem,VIcon,VListItemAvatar,VSpacer})
